export default {
    apply_schedule: {
        heading: 'Do you want to apply the selected slots?',
        apply: 'Apply slots',
    },
    apply_removed_schedule: {
        heading: 'Do you want to apply the following changes?',
        time_label: 'Remove time slot ',
        apply: 'Apply changes',
    },
    cannot_remove_all: {
        message: 'You cannot remove all the time slots from your schedule.',
        button: 'OK, Understood',
    },
    make_direct_referal_modal: {
        refer_directly_provider: 'Refer directly to a provider',
        refer_directly_physican: 'Refer directly to provider',
        refer_directly_ancillary: 'Refer directly to ancillary',
        check_availability: 'Check availability',
        physician_or_ancillary: 'Provider or Ancillary Service',
        physician: 'Provider',
        ancillary: 'Ancillary Service',
        start_typing: 'Start typing...',
        practice_lookup_failed: "We couldn't load this provider's practices. Please try again.",
        content: '<u><b>DOES NOT ACCEPT<b></u>',
        insurance_plans: '{insurance} plans.',
        try_with_another: 'Try with another provider',
        or: 'OR',
        availability: 'AVAILABILITY',
        invite_sent: 'Invite sent!',
        invite_sent_to_email: 'We sent an invitation to <a>{email}</a>',
        buttons: {
            search_physician: 'Go Back',
            match_referral: 'Match Referral',
            find_provider: "Would you like to find a provider in your patient's network?",
        },
        invite: {
            heading: '{name} is not a member of the MedMatch Network',
            content: 'To create referral, please provide additional information',
            already_invited: 'User {email} already invited',
            already_registered: 'User {name} already registered',
            already_deactivated: 'User {name} deactivated',
            buttons: {
                send_invite: 'Send Invite',
                collect_contacts: 'Add',
            },
        },
        inivte_billing: {
            default_plan: 'is on default NETWORK plan and is not able to recieve referrals.',
            subscribe_to_premium: 'Subscribe to PREMIUM',
            click: 'click',
            here: 'HERE',
            premium: 'to invite them to PREMIUM plan',
            invite_success: 'Invitation has been sent!',
        },
    },
    send_join_invites_modal: {
        import_contacts_modal: {
            send_button: 'Add',
            invite_by_email: 'Invite by email',
            invite_by_phone: 'Invite by phone',
        },
    },
    send_join_invites_modal_check_emails: {
        heading: '{newInvites} out of {totalInvites} invites sent!',
        sub_header_invitations: '{count} email previously invited, re-invite in network section',
        sub_header_invitations_plural: '{count} emails previously invited, re-invite in network section',
        sub_header_members: '{count} email is a member. Please search and add member to your network',
        sub_header_members_plural: '{count} emails are members. Please search and add members to your network',
        sub_header_registration_not_completed: '{count} email is already registered, but has not completed registration',
        sub_header_registration_not_completed_plural:
            '{count} emails are already registered, but have not completed registration',
        users_list_members_header: 'HAVE ALREADY JOINED MEDMATCH',
        users_list_registration_not_completed_header: 'HAVE NOT COMPLETED REGISTRATION',
        physician: 'Provider',
        ancillary: 'Ancillary Services Practice',
        close_button: 'Close',
    },
    request_consultation_report_modal: {
        heading: 'Request report to {name}',
        text_area_label: 'Add a message for {name} (Optional)',
        text_area_placeholder: 'Type your message for {name} here...',
        buttons: {
            send_request: 'Send request',
        },
    },
    upload_report_leave_modal: {
        warning: 'The uploaded files have not been sent!',
        text: 'Do you want to send them now?',
        buttons: {
            dont_send: "Don't send",
            send_files: 'Send files',
        },
    },
    upload_note_modal: {
        patient: 'Patient: {name}',
        diagnosis: 'Diagnosis: {diagnosis}',
        heading: 'Please, upload patient records',
        buttons: {
            upload_more: 'Upload more',
            confirm: 'Confirm',
            load_more: 'Load more',
            upload_files: 'Upload files',
            add_files: 'Add files',
        },
    },
    primary_care_email_modal: {
        heading: 'Without the primary care email address you will have to call to receive authorization.',
        add_email: 'Add email address and request appointment',
        continue_without_email: 'Continue without email address',
        or: 'OR',
        buttons: {
            add_email: 'Add email address',
            request_appointment: 'Request appointment',
        },
        inputs: {
            email: {
                placeholder: 'provider@email.com',
                label: 'Primary care email address',
            },
        },
    },
    join_invites_error_modal: {
        heading: {
            array_max: 'Maximum number of 25 email invitations per request exceeded',
            default: 'There was an error, please try again',
        },
        close_button: 'Close',
    },
    join_invites_member: {
        heading: 'Invite your practice members to join {practiceName}',
        label: 'Member',
        placeholder: 'member@email.com',
        invites_sent: 'Invites sent!',
    },
    practice_privileges_modal: {
        confirm_membership: 'Confirm {name} membership',
        user_membership: '{name} membership',
        specify_privileges: "Please specify {name}'s privileges on the {practiceName} account",
        availability_privilege: 'Can set/modify providers availability',
        practice_membership_privilege: 'Can manage practice membership',
        can_activate_another_user: 'Can activate another provider',
    },
    remove_practice_member_modal: {
        heading: 'Are you sure you want to remove {name}?',
        content: 'By clicking on "CONFIRM" {name} will be permanently removed from your practice account.',
    },

    resend_invitation_email: {
        heading: 'Are you sure you want to reinvite {name}?',
    },

    search_and_add_members: {
        heading: 'Grow your Network',
        content: 'Search for a member and add to your network.',
        search_placeholder: 'Search by name',
        back_to_search: 'BACK TO SEARCH',
        add_to_network: 'Add to my Network',
    },
    remove_professional_info: {
        heading: 'Are you sure you want to remove this {name}?',
    },
    change_password: {
        title: 'Change Password',
        content: 'New password have at least 10 characters',
    },
    change_email: {
        title: 'Change email address',
        content: 'We will send you an email to confirm your new email',
    },
    change_practice_email: {
        heading: 'Change email address',
        content: 'Enter your new practice email address',
    },
    change_ancillary_email: {
        content: 'Enter your new company email address',
    },
    profile_photo_upload_modal: {
        upload_new: 'Upload new',
    },
    import_contacts_modal: {
        label: {
            import: 'Import your contacts from: ',
            invite: 'or invite by email address',
        },
        buttons: {
            sign_in_with: 'Sign in with {api}',
        },
        warning_messages: {
            no_contacts: 'You have no {emailProvider} contacts - please add contacts and try again.',
            no_contact_emails: 'Your contacts do not have an email address attached.',
        },
        loading: 'Loading...',
    },
    contact_collector: {
        warning_message: 'Maximum number of selected contacts is: {message}',
    },
    referral_chat_modal: {
        loading_messages: 'Loading messages...',
        text_editor_placeholder: 'Type your message for Dr. {name}',
        send_message_button: 'Send',
        recipient_header: 'Messaging: {name}',
        recipient_patient_header: 'Messaging patient: {name}',
        patient_header: 'Patient name: {name}',
        not_aprooved_patient: 'Accept referral to see patient name.',
    },
    referral_unread_messages: {
        no_new_messages: 'No new messages.',
    },
    search_network_members: {
        loading_message: 'Loading...',
        no_members_in_network: 'You have no members in your network',
        no_member_found: 'No member found',
    },
    patient_agrees: {
        header: 'SMS messaging terms and conditions',
        footer: '*If choose NO, patient will not receive SMS notifications',
        policy: `<a href="${env('VUE_APP_WP_URL')}/privacy-policy" target="_new">Privacy Policy</a>`,
        and: 'and',
        terms: `<a href="${env('VUE_APP_WP_URL')}/terms-of-service" target="_new">Terms of Service</a>.`,
        agrees_sms: 'Patient agrees to receive SMS with information about referral',
        message_data: 'Messages and data rates may apply',
        messages_per_referral: 'Patient may receive up to 3 messages per referral',
    },
    notifications: {
        no_notifications: 'There isn`t any notifications yet',
        new_member_near_by: 'New provider near you:',
    },
    please_register: {
        heading: 'Please create profile to continue!',
    },
    delete_patient: {
        title: 'Confirm Delete',
        content: 'Are you sure you want to delete this patient?',
        buttons: {
            save: 'Ok',
            cancel: 'Cancel',
        },
    },
    patient_massege: {
        title: 'Patient Message',
        buttons: {
            save: 'Ok',
            cancel: 'Cancel',
        },
    },
    patient_record: {
        title: 'Patient Record',
        buttons: {
            save: 'Save',
            cancel: 'Cancel',
        },
        add: {
            upload_records: 'Upload records',
            file_limits: 'PDF, PNG, JPG OR JPEG - 50MB maximum file size',
            warnings: {
                error: '{n} file(s) could not be uploaded',
            },
        },
        upload: 'Upload',
        upload_success: 'Files uploaded successfully',
    },
    refer_patient: {
        button: {
            notification: 'Notification',
        },
        buttons: {
            refer: 'Refer Patient',
        },
    },
    pageData: {
        header: {
            subtitle: 'Import your patient list now',
        },
        uploadSection: {
            title: 'Upload patients list',
            fileInfo:
                '.csv or .excel format. Make sure you enter the following details: First Name, Last Name, Phone, Email, DOB, SSN',
        },
        buttons: {
            upload: 'CONTINUE',
            addPatient: 'ADD PATIENT',
        },
        fileUploadText: {
            browse: 'Browse Files',
            dragDrop: 'Drag and drop files here',
        },
        status: {
            loadingText: 'Uploading...',
            orText: 'or add them one by one',
        },
        sampleFile: {
            text: 'Download sample file',
        },
        uploadWrongFileError: {
            text: 'File type is not supported. Please upload a CSV or Excel file.',
        },
    },
    sidebarList: {
        content: {
            record: 'Patient Records',
            message: 'Message Patient',
            information: 'Edit Patient Information',
            general_intake: 'General Intake Form',
            accident_intake: 'Accident Intake Form',
            remove: 'Delete Patient',
        },
        physician: {
            title: 'Primary Care Physician',
            dr: 'Dr.',
        },
    },
    header_layout: {
        back: {
            title: 'Back to patients',
        },
    },
    patint_form: {
        name: 'Patient Name:',
        date: {
            title: 'Date of birth:',
        },
        group: {
            title: 'Group #',
        },
        id: {
            title: 'ID',
        },
        message: {
            title: 'Message Dr.',
        },
        primary: {
            care: 'Primary Care',
            insurance: 'Insurance',
        },
        clinical: {
            title: 'Clinical History',
        },
        report: 'Consultation report:',
    },
    member_card: {
        lastvisit: {
            title: 'Last visit:',
        },
    },

    patient: {
        address: {
            title: 'Address',
        },
        year: {
            title: '{age} yrs',
        },
        insurance: {
            title: 'Insurance Information',
            group: 'Group:',
            id: 'Id:',
        },
        provider: {
            title: 'Primary Care Provider',
        },
        tab: {
            label_one: 'Appointments',
            label_two: 'Documents',
            label_three: 'Profile',
            label_four: 'Summary by Edha',
        },
        feature_coming_soon: 'This feature will arrive soon',
        medical: {
            title: 'Export Timeline',
            heading: 'Medical Timeline',
            head: 'Current Status',
            time_head: 'Medical Timeline',
            no_appointments: 'No appointments found',
            subtitle: 'Complete chronological medical history and appointments',
            blue_card: {
                card_head: 'Active Conditions',
                card_subtitle: 'No active conditions',
                card_detail: 'None reported',
                active_conditions: '{count} active conditions',
                under_monitoring: 'Under monitoring',
            },
            green_card: {
                card_head: 'Recent Tests',
                card_subtitle: 'No recent tests',
                card_detail: 'No test records',
                tests_recorded: '{count} tests recorded',
                tests_with_group: '{count} tests ({group})',
                single_test_with_group: '{count} test ({group})',
                recent_test_completed: 'Recent test completed',
            },
            purple_card: {
                card_head: 'Next Appointment',
                card_subtitle: 'No upcoming appointments',
                card_detail: 'None scheduled',
                appointment_with: 'Appointment with {name}',
                follow_up_scheduled: 'Follow-up scheduled',
            },
            steps: {
                referral: 'Referral',
                followUp: 'Follow-up Visit',
                view: 'View Details',
                contect: 'Contact Provider',
                diagnosis_name: 'Diagnosis',
                load: 'Load Earlier Records',
            },
            view_modal: {
                provider_practice: 'Provider & Practice',
                patient_info: 'Patient Information',
                appointment_location: 'Appointment & Location',
                clinical_info: 'Clinical Information',
                labels: {
                    provider: 'Provider:',
                    speciality: 'Speciality:',
                    practice: 'Practice:',
                    name: 'Name:',
                    dob: 'DOB:',
                    email: 'Email:',
                    date_time: 'Date & Time:',
                    location: 'Location:',
                    diagnosis: 'Diagnosis:',
                    insurance_plan: 'Insurance Plan:',
                    status_details: 'Status Details:',
                },
                na: 'N/A',
            },
            contact_modal: {
                default_provider: 'Provider',
                email: 'Email',
                phone: 'Phone',
                send_email: 'Send Email',
                call_phone: 'Call Phone',
                na: 'N/A',
            },
            export_modal: {
                report_title: 'MEDICAL TIMELINE REPORT',
                no_appointments_timeline: 'No appointments found in timeline.',
                download_pdf: 'Download PDF',
                popup_warning: 'Please allow popups to print the timeline',
                keys: {
                    status: 'Status',
                    provider: 'Provider',
                    speciality: 'Speciality',
                    location: 'Location',
                    diagnosis: 'Diagnosis',
                    insurance_plan: 'Insurance Plan',
                },
                na: 'N/A',
            },
        },
    },

    patient_profile: {
        profile: {
            card_head: 'Patient Demographics',
            contact_info: {
                card_head: 'Contact Information',
                preferred_method: 'Preferred Contact Method',
                preferred_method_value: 'Phone',
            },
            address: {
                card_head: 'Address Information',
            },
            emergency: {
                card_head: 'Emergency Contacts',
            },
            pharmacy: {
                card_head: 'Preferred Pharmacy',
                name: 'CVS Pharmacy',
                address: '1250 Beach Blvd, Jacksonville, FL 32207',
                phone: '904-398-2200',
                fax: 'Fax: 904-398-2201',
                hours: 'Mon-Fri: 8AM–10PM, Sat-Sun: 9AM–8PM',
                tag: 'Preferred',
                email: 'Email',
            },
            providers: {
                card_head: 'Provider Network',
                primary: 'Primary',
                in_network: 'In Network',
            },
            preferences: {
                card_head: 'Patient Preferences',
                list: {
                    reminders: 'Appointment Reminders',
                    email: 'SMS and Email',
                    restrictions: 'Dietary Restrictions',
                    restrictions_value: 'None',
                    communication: 'Communication Language',
                    communication_value: 'English',
                    considerations: 'Religious Considerations',
                    considerations_value: 'None specified',
                    accessibility: 'Accessibility Needs',
                    accessibility_value: 'None required',
                },
            },
            healthcare: {
                card_head: 'Healthcare Directives',
                list: {
                    reminders: 'Advance Directive',
                    email: 'On file',
                    restrictions: 'Organ Dono',
                    restrictions_value: 'Yes',
                    communication: 'Power of Attorney',
                    communication_value: 'Sarah David',
                    considerations: 'DNR Status',
                    considerations_value: 'No',
                },
            },
            request: {
                medication: {
                    selected_provider: 'Selected Provider:',
                    secure: 'Records will be requested through the secure Medmatch Network platform.',
                },
                hipaa: {
                    no_hipaa: 'No active HIPAA forms available.',
                    upload_hipaa: 'Upload a HIPAA authorization form first.',
                    scope: 'Scope:',
                    choose_file: 'Choose file',
                },
                record_request: {
                    req: 'REQ',
                    network: 'Medmatch Network',
                    emails: 'Email Request',
                    details_modal: {
                        req_details: 'Request Details -',
                        req_date: 'Request Date',
                        req_records: 'Requested Records',
                        hipaa_auth: 'HIPAA Authorization',
                    },
                },
                no_record_request_found: 'No Record Requests made till now',
                no_providers_found: 'No providers found matching your search',
                notification: 'Request for Medical Records Sent',
                card_head: 'Request Medical Records',
                tabs: {
                    medmatch: 'Provider Registry',
                    request: 'Email Request',
                    hippa: 'HIPAA Forms',
                    fax: 'Fax Request',
                },
                select: 'Select',
                detail: 'Request Medical Records',
                search: 'Search Providers',
                verify: '✔ Verified Network',
                record: 'What records do you need? *',
                range: 'Date Range (Optional)',
                email_head: 'Provider Email Information',
                list_one: ' Complete Medical History',
                list_two: 'Lab Results',
                list_three: ' Imaging Reports',
                list_four: 'Consultation Notes',
                list_five: 'Prescription History',
                list_six: 'Surgical Records',
                list_seven: ' Immunization Records',
                list_eight: ' Mental Health Records',
                fax_title: 'Provider Fax Information',
            },
            detail_form: {
                card_head: 'Medical Documents ({count})',
                card_heading: 'Document preview would appear here',
                delete_success: 'Document deleted successfully.',
                delete_error: 'Failed to delete document. Please try again.',
                select_all: 'Select all',
                share_button: 'Share',
                shared_links_button: 'Shared links',
                shared_links: {
                    heading: 'Shared links',
                    empty: 'You have not shared any documents yet.',
                    link_only: 'Link only',
                    documents: '{count} document(s)',
                    expires: 'Expires {date}',
                    status_active: 'Active',
                    status_expired: 'Expired',
                    status_revoked: 'Revoked',
                    revoke: 'Revoke',
                    revoke_confirm: 'Revoke this link? The recipient will lose access immediately.',
                    revoked: 'Link revoked',
                },
                share_modal: {
                    heading: 'Share with',
                    subtitle: '{count} document(s) selected to share:',
                    recipient_label: 'Share with',
                    recipient_placeholder: 'Select or type recipient...',
                    no_recipients_found: 'No matching recipient found',
                    clear_selection: 'Clear selection',
                    email_label: 'Recipient email (optional)',
                    email_placeholder: 'colleague@example.com',
                    copy_link: 'Copy Link',
                    send: 'Send',
                    create_link: 'Create link',
                    sent: 'Link sent to {email}',
                    email_failed: 'Link created, but the email could not be sent. Copy the link below instead.',
                    created: 'Link created — copy it below',
                    copied: 'Link copied — paste it anywhere',
                    access_code_label: 'Access code',
                    copy_access_code: 'Copy code',
                    access_code_copied: 'Access code copied',
                },
                delete_modal: {
                    heading: 'Delete Document',
                    message: 'Are you sure you want to delete this document? This action cannot be undone.',
                    confirm: 'Delete',
                    cancel: 'Cancel',
                },
                button: {
                    title: 'Download',
                    edit: 'Edit',
                },
                document_detail: {
                    title: 'Document Details',
                    type: 'Type:',
                    date: 'Date:',
                    provider: 'Provider:',
                    size: 'Size:',
                    description: 'Description',
                    button: {
                        title: 'Back to Documents',
                    },
                },
                tabs: {
                    view: 'View Documents',
                    upload: 'Upload New',
                    request: 'Request Records',
                    request_inbox: 'Record Requests Inbox',
                    hipaa: 'HIPAA Forms',
                    intake: {
                        item: 'Intake Forms',
                        subitem: {
                            general: 'General',
                            accident: 'Accident',
                        },
                    },
                },

                refer_patient_tab: {
                    heading: "Choose how you'd like to refer this patient",
                    subheading:
                        'Select a referral method below to connect this patient with healthcare providers or ancillary services.',
                    direct_description:
                        'Send an instant referral request directly to a specific provider or facility within your network.',
                    match_description:
                        'Broaden your search criteria to find available specialists and facilities tailored to insurance and location.',
                    epres_description: 'Issue digital referral scripts and medical orders directly to your patient.',
                    security_note: 'All referral options are secure, HIPAA-compliant, and tracked in real time.',
                    modal_direct_title: 'Choose Direct Referral Type',
                    modal_direct_subtitle:
                        'Select whether you want to refer directly to a healthcare provider or an ancillary facility.',
                    modal_match_title: 'Choose Match Referral Type',
                    modal_match_subtitle:
                        'Select whether you want to match this patient with a provider or an ancillary facility.',
                    provider_title: 'Healthcare Provider',
                    provider_desc: 'Refer directly to a doctor, specialist, or surgeon in your network.',
                    ancillary_title: 'Ancillary Facility',
                    ancillary_desc: 'Refer directly to imaging centers, labs, physical therapy, or diagnostic clinics.',
                    match_provider_desc: 'Find and match available physicians and specialists based on location and insurance.',
                    match_ancillary_desc: 'Find and match available imaging centers, labs, or therapy clinics.',
                },
                message_patient_tab: {
                    heading: 'Direct Conversation',
                    no_message: 'No messages yet. Send a message to start the conversation.',
                    textbox: 'Type a message to the patient...',
                    press: 'Press',
                    enter: 'Enter',
                    to_send: 'to send,',
                    shift_enter: 'Shift + Enter',
                    new_line: 'for a new line',
                },
                filters: {
                    search_placeholder: 'Search documents...',
                    type: {
                        all: 'All Types',
                        lab: 'Lab Results',
                        imaging: 'Imaging',
                        consultation: 'Consultation',
                        prescription: 'Prescription',
                    },
                    provider: {
                        all: 'All Providers',
                        quest: 'Quest Diagnostics',
                        radiology: 'Radiology Associates',
                        smith: 'Dr. Smith',
                        pharmacy: 'Downtown Pharmacy',
                    },
                },
                document_list: {
                    card_head: 'Patient Documents',
                },
                detail_view: {
                    details: 'Document Details',
                    fields: {
                        type: 'Type',
                        date: 'Date',
                        provider: 'Provider',
                        size: 'Size',
                        status: 'Status',
                    },
                    description: 'Description',
                    status_active: 'active',
                    back_btn: 'Back to Documents',
                    download_btn: '⬇️ Download',
                },
                upload: {
                    head: 'Upload Medical Records',
                    title: 'Upload Medical Records',
                    drop_text: 'Drop files here or click to browse',
                    subtext: 'Supports PDF, CSV, and images (Max 50MB per file)',
                    uploadbutton: {
                        title: ' Upload Documents',
                    },
                    fields: {
                        type: 'Document Type',
                        date: 'Document Date',
                        provider: 'Provider/Source',
                        comments: 'Comments',
                    },
                    placeholders: {
                        type: 'Select document type',
                        date: 'dd-mm-yyyy',
                        provider: 'e.g., Dr. Smith, ABC Hospital',
                        comments: 'Additional notes about this document',
                    },
                    options: {
                        type: ['Prescription', 'Lab Report', 'Discharge Summary'],
                    },
                    button: 'Upload Documents',
                },
                request: {
                    title: 'Request Records',
                },
            },
            summary_detail: {
                brief_history: {
                    title: 'Brief History',
                },
                past_history: {
                    title: 'Past Medical History',
                },
                past_surgical: {
                    title: 'Past Surgical History',
                },
                allergies_detail: {
                    title: 'Allergies',
                },
                current_detail: {
                    title: 'Current Medications',
                },
                family_detail: {
                    title: 'Family History',
                },
                social_history: {
                    title: 'Social History',
                },
                review: {
                    title: 'Review of Systems',
                },
                summary: {
                    title: 'Summary by Edha',
                    subtitle: 'AI-powered medical summary and record analysis',
                },
                symptoms: {
                    head: 'Ask Edha About This Patient',
                    placeholder: 'Ask about medications, symptoms, test results, family history...',
                    question: 'What are the patient’s current symptoms?',
                    answer: 'The patient is experiencing periodic headaches that have improved by 60% with current treatment. The headaches are not intractable and have shown good response to Topiramate therapy.',
                    date: '2025-02-13 10:30 AM',
                },
                history: {
                    brief: '37-year-old male presenting with periodic headache syndromes. Initially evaluated in emergency department for severe headache with associated nausea and photophobia. Subsequent neurological workup including brain MRI showed no structural abnormalities. Currently managed with preventive medication showing good clinical response.',
                    pastMedical: {
                        list_one: 'Periodic headache syndromes (2024–present)',
                        list_two: 'No history of diabetes mellitus',
                        list_three: 'No history of hypertension',
                        list_four: 'No history of cardiovascular disease',
                    },
                },
                surgicalHistory: 'No prior surgical procedures',
                allergies: 'No known drug allergies',
                medications: {
                    name: 'Topiramate',
                    dose: '50mg',
                    frequency: 'Twice daily',
                    indication: 'Headache prevention',
                    started: '20/01/2025',
                },
                familyHistory: {
                    list_one: 'Father: Hypertension, alive',
                    list_two: 'Mother: No significant medical history, alive',
                    list_three: 'Siblings: No known medical conditions',
                    list_four: 'No family history of neurological disorders',
                    list_five: 'No family history of migraines',
                },
                socialHistory: {
                    Occupation: 'occupation',
                    Occupation_value: 'Professional (office work)',
                    Smoking: 'Smoking',
                    Smoking_value: 'Never smoked',
                    Alcohol: 'Alcohol',
                    Alcohol_value: 'Occasional social drinking',
                    Drugs: 'Drugs',
                    Drugs_value: 'Denies illicit drug use',
                    Exercise: ' Exercise',
                    Exercise_value: 'Regular exercise 3x per week',
                    Marital: 'Marital Status',
                    Marital_Status: 'Single',
                },
                reviewOfSystems: {
                    Constitutional: 'constitutional',
                    Constitutional_value: 'Denies fever, weight loss, night sweats',
                    Neurological: 'Neurological',
                    Neurological_value: 'Periodic headaches as described, no focal neurological symptoms',
                    Cardiovascular: 'Cardiovascular',
                    Cardiovascular_value: 'No chest pain, palpitations, or shortness of breath',
                    Respiratory: 'Respiratory',
                    Respiratory_value: 'No cough, shortness of breath, or wheezing',
                    Gastrointestinal: 'Gastrointestinal',
                    Gastrointestinal_value: 'No nausea, vomiting, or abdominal pain (except during headache episodes)',
                    Genitourinary: 'Genitourinary',
                    Genitourinary_value: 'No urinary symptoms',
                    Musculoskeletal: 'Musculoskeletal',
                    Musculoskeletal_value: 'No joint pain or muscle weakness',
                    Dermatologic: 'Dermatologic',
                    Dermatologic_value: 'No rashes or skin changes',
                },
                blood: {
                    head: 'Physical Examination',
                    title: 'Blood Pressure',
                    subtitle: '118/75 mmHg',
                    sign: 'Vital Signs',
                },
                heart_rate: {
                    title: 'Heart Rate ',
                    subtitle: '68 bpm',
                },
                temperature: {
                    title: 'Temperature',
                    subtitle: '98.6°F (37°C)',
                },
                respiratory: {
                    title: 'Respiratory Rate',
                    subtitle: '16/min',
                },
                oxygen: {
                    title: 'Oxygen Saturation',
                    subtitle: '99% on room air',
                },
                general: {
                    title: 'General',
                    subtitle: 'Well-appearing, alert and oriented x3, no acute distress',
                },
                neurological: {
                    title: 'Neurological',
                    subtitle:
                        ' Cranial nerves II-XII intact, motor strength 5/5 throughout, reflexes 2+ and symmetric, normal coordination and gait',
                },
                cardiovascular: {
                    title: 'Cardiovascular',
                    subtitle: 'Regular rate and rhythm, no murmurs, rubs, or gallops',
                },
                respiratory_detail: {
                    title: 'Respiratory',
                    subtitle: 'Clear to auscultation bilaterally',
                },
                abdominal: {
                    title: 'Abdominal',
                    subtitle: 'Soft, non-tender, no organomegaly',
                },
                imaging: {
                    head: 'Imaging Reports',
                    title: 'Brain MRI with and without contrast',
                    subtitle: '28/01/2025',
                },
                findings: {
                    title: 'Findings:',
                    subtitle:
                        ' No acute intracranial abnormality. No evidence of mass effect, midline shift, or abnormal enhancement. Normal brain parenchyma, ventricles, and cisterns.',
                },
                impression: {
                    title: 'Impression:',
                    subtitle: ' Normal brain MRI',
                },
                emergency: {
                    title: 'CT Head (Emergency Department)',
                    subtitle: '22/12/2024',
                },
                findings_detail: {
                    title: 'Findings:',
                    subtitle:
                        ' No acute intracranial hemorrhage, mass effect, or midline shift. Normal gray-white matter differentiation.',
                },
                impression_details: {
                    title: 'Impression:',
                    subtitle: ' Normal non-contrast CT head',
                },
                diagnoses: {
                    head: 'Diagnoses',
                    heading: 'Primary',
                    title: 'G43.909',
                    subtitle: ' Active',
                },
                diagnoses_details: {
                    subtitle: 'Periodic headache syndromes in child or adult, not intractable, without status migrainosus',
                },
            },
            hippa_detail: {
                notification: 'Your Hipaa Form Uploaded Successfully',
                head: 'Your HIPAA Authorization Forms',
                active: '{n} Active Form(s)',
                header: {
                    title: 'General HIPAA Authorization',
                    active: 'active',
                    inactive: 'inactive',
                },
                button: {
                    view: 'View',
                    download: 'Download',
                },
                file: {
                    file_title: 'File:',
                    title: 'hipaa_authorization_signed_2025.pdf',
                    upload_title: 'Uploaded:',
                    upload: ' 15/01/2025',
                    scope: ' Complete medical records access',
                    size_title: 'Size:',
                    size: ' 2.1 MB',
                    provide: 'All healthcare providers',
                    expires_title: 'Expires: ',
                    expires: '15/01/2026',
                },
                upload: {
                    head: 'Upload New HIPAA Authorization Form',
                    drop_text: 'Upload Signed HIPAA Form',
                    subtext: 'PDF, JPG, PNG - Max 50MB',
                    button: 'Save HIPAA Form',
                    download: 'Download blank HIPAA form',
                },
            },
            record_form: {
                head: 'Recent Record Requests',
                details: [
                    {
                        id: 'REQ001',
                        hospital: 'St. Mary’s Hospital',
                        status: 'Pending',
                        network: 'Medmatch Network',
                        date: '15/01/2025',
                        expected: '22/01/2025',
                        records: 'Complete Medical History',
                        notes: 'Patient needs records for specialist consultation',
                    },
                    {
                        id: 'REQ002',
                        hospital: 'Downtown Clinic',
                        status: 'Received',
                        date: '10/01/2025',
                        records: 'Lab Results',
                        notes: 'Blood work from last month',
                        email: true,
                        download: true,
                    },
                    {
                        id: 'REQ003',
                        hospital: 'Jacksonville General Hospital',
                        status: 'Approved',
                        network: 'Medmatch Network',
                        date: '08/01/2025',
                        expected: '18/01/2025',
                        records: 'Imaging Reports, Consultation Notes',
                        notes: 'MRI and consultation reports needed for ongoing treatment',
                    },
                    {
                        id: 'REQ004',
                        hospital: 'Northeast Mental Health Center',
                        status: 'Rejected',
                        date: '05/01/2025',
                        records: 'Mental Health Records',
                        notes: 'Request denied - incomplete authorization form',
                        email: true,
                    },
                ],
                button: {
                    title: 'Details',
                    downloadtitle: ' Download',
                },
                request_id: {
                    id: 'Request ID:',
                    date: 'Date:',
                    expected: 'Expected:',
                },
                record: {
                    name: 'Records:',
                },
                notes: {
                    name: 'Notes:',
                },
            },
            type: {
                text: 'All Types',
            },
            source: {
                text: 'All Providers',
            },
        },
    },
    referral_detail_modal: {
        created_on: 'Created on:',
        note: 'Note:',
    },
    upload_records_modal: {
        title: 'Record Requests',
        pending: 'Pending',
        fulfilled: 'Fulfilled',
        requests: 'Requests {n}',
        documents_requested: '{n} {label} requested',
        doc: 'doc',
        docs: 'docs',
        note_title: 'Provider Request Note:',
        requested_docs: 'Requested Documents:',
        upload: {
            title: 'Upload Documents:',
            drag: 'Drag and drop files here or',
            browse: 'browse',
            optional_note: 'Optional Note:',
            placeholder: 'Add an optional note for this upload...',
        },
    },
}
